(function() {
  'use strict';

  var userClicked = false;

  // Close the review modal unless the user actually clicked a review button
  function closeIfAutoOpened() {
    if (userClicked) return;
    var modal = document.getElementById('rvw-modal-ov');
    if (modal && modal.classList.contains('open')) {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  // Watch for the modal opening at ANY time via MutationObserver
  function watchModal() {
    var modal = document.getElementById('rvw-modal-ov');
    if (!modal) {
      setTimeout(watchModal, 100);
      return;
    }
    var observer = new MutationObserver(function() {
      closeIfAutoOpened();
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
    // Also close immediately if already open on attach
    closeIfAutoOpened();
  }

  // Track genuine user clicks on review buttons — set flag BEFORE the onclick fires
  document.addEventListener('click', function(e) {
    var el = e.target;
    while (el && el !== document) {
      if (el.classList &&
         (el.classList.contains('rvw-write-link') ||
          el.classList.contains('prod-no-reviews'))) {
        userClicked = true;
        // Reset after modal opens so subsequent pages start fresh
        setTimeout(function() { userClicked = false; }, 3000);
        return;
      }
      var oc = el.getAttribute && el.getAttribute('onclick');
      if (oc && oc.indexOf('rvwOpenForm') !== -1) {
        userClicked = true;
        setTimeout(function() { userClicked = false; }, 3000);
        return;
      }
      el = el.parentElement;
    }
  }, true);

  // Start watching
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchModal);
  } else {
    watchModal();
  }

})();
